module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "media-add-piece"
    }
  }, [_c('h2', [_vm._v("Add a Piece")]), _vm._v(" "), (!_vm.savingForm) ? _c('form', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Piece Title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('fieldset', _vm._l((_vm.mediaTypes), function(mediaType) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMediaType),
        expression: "selectedMediaType"
      }],
      attrs: {
        "type": "radio",
        "name": "mediaType"
      },
      domProps: {
        "value": mediaType.id,
        "checked": _vm._q(_vm.selectedMediaType, mediaType.id)
      },
      on: {
        "__c": function($event) {
          _vm.selectedMediaType = mediaType.id
        }
      }
    }), _vm._v(" " + _vm._s(mediaType.name))])
  })), _vm._v(" "), _c('label', [_c('markdown-editor', {
    attrs: {
      "placeholder": "Description (Optional)"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMediaData.usesUploadFile),
      expression: "selectedMediaData.usesUploadFile"
    }]
  }, [_vm._v("\n                Media (" + _vm._s(_vm.selectedMediaData.name) + ")\n                "), _c('input', {
    attrs: {
      "type": "file",
      "id": "mediaPieceFile",
      "name": "mediaPieceFile",
      "accept": _vm.selectedMediaData.acceptedTypes.join(',')
    },
    on: {
      "change": _vm.setMediaFile
    }
  }), _vm._v(" "), _c('span', [_vm._v("Accepted File Types: " + _vm._s(_vm.selectedMediaData.acceptedTypes.join(', ')))])]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMediaData.usesExternalUrl),
      expression: "selectedMediaData.usesExternalUrl"
    }]
  }, [_vm._v("\n                Media (External Url) "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mediaText),
      expression: "mediaText"
    }],
    attrs: {
      "type": "text",
      "name": "mediaPieceText",
      "placeholder": "http://..."
    },
    domProps: {
      "value": (_vm.mediaText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mediaText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMediaData.usesYoutubeLink),
      expression: "selectedMediaData.usesYoutubeLink"
    }]
  }, [_vm._v("\n                Youtube Link "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mediaText),
      expression: "mediaText"
    }],
    attrs: {
      "type": "text",
      "name": "mediaPieceText",
      "placeholder": "http://..."
    },
    domProps: {
      "value": (_vm.mediaText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mediaText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMediaData.usesPreviewImage),
      expression: "selectedMediaData.usesPreviewImage"
    }]
  }, [_vm._v("\n                Preview Image (optional)\n                "), _c('input', {
    attrs: {
      "type": "file",
      "id": "previewFile",
      "name": "previewFile",
      "accept": ".jpg,.jpeg,.gif,.png"
    },
    on: {
      "change": _vm.setPreviewFile
    }
  }), _vm._v(" "), _c('span', [_vm._v("Accepted File Types: .jpg, .jpeg, .png, .gif")])])]), _vm._v(" "), _c('fieldset', [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelPiece($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitNewPiece($event)
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('fieldset', [_c('ul', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(formError) {
    return _c('li', [_vm._v(_vm._s(formError))])
  }))]) : _vm._e()]) : _c('saver-large')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d046785!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Media/FormNewMediaPiece.vue
// module id = 821
// module chunks = 2